import DirectorSettings from './DirectorSettings';

export default DirectorSettings;
